import * as Sentry from "@sentry/react"
import { useEffect } from "react"

export function useErrorTrackingInfo(
    key: string,
    value: number | string | boolean | bigint | symbol | undefined
) {
    if (value !== undefined) {
        Sentry.setTag(key, value)
    }

    useEffect(() => {
        return () => Sentry.setTag(key, undefined)
    }, [key])
}
